module.exports = __webpack_public_path__ + "static/update_plots.7467c845.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apps/bcj/update_plots.png
// module id = 185
// module chunks = 189712120597197 266278358803734